export const CarketaDisclosure = () => {
  return (
    <div className="flex w-full text-xs tracking-tighter">
      {`"Carketa Disclosure: The contents of these documents are intended
    purely for informational purposes and do not constitute any form of
    assurance or certification regarding the present or future condition or
    performance of the vehicle. It is strongly advised that customers
    conduct independent verification of the information provided and
    exercise prudent judgment when evaluating the vehicle's condition and
    appropriateness for their requirements. Please note that these documents
    may not encompass all updates or alterations subsequent to
    manufacturing, and they do not function as warranties or guarantees of
    the vehicle's condition."`}
    </div>
  );
};

export default CarketaDisclosure;
